import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=b0cfa308&scoped=true&"
import script from "./modify.vue?vue&type=script&lang=js&"
export * from "./modify.vue?vue&type=script&lang=js&"
import style0 from "./modify.vue?vue&type=style&index=0&id=b0cfa308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cfa308",
  null
  
)

export default component.exports